import * as React from "react";
import { forwardRef } from "react";
const SvgLeftOutlined = (props, ref) => /* @__PURE__ */ React.createElement("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 6 8",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M5.5 0.991064L2.48568 4L5.5 7.00894L4.50716 8L0.5 4L4.50716 0L5.5 0.991064Z",
	fill: "currentColor"
}));
const ForwardRef = forwardRef(SvgLeftOutlined);
export default ForwardRef;
